import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-image-overlay-container" }

import ImageOverlayItem from "./image-overlay-item.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'image-overlay',
  props: {
    type: String,
    link: String,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ImageOverlayItem, {
      link: __props.link,
      type: __props.type
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ], undefined, true),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["link", "type"])
  ]))
}
}

})